import * as React from "react";
import { observer } from "mobx-react";
import { Button as ButtonJS, Classes } from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { toast } from "react-toastify";
import { validarCNPJ } from "../../utils";

const steps = ['Dados da empresa', 'Tributações de Entrada', 'Segmentos'];

require("../../assets/css/components/EmpresaForm.css");


interface Props {
  doSave: () => void;
  onClose: () => void;
}

@observer
export default class EmpresaResumo extends React.Component<Props, any> {
  obs = observable({
    activeStep: 0 as number,
    skipped: 0 as number,
  })

  handleSave = async () => {

    if (!EmpresaStore.obs.cnpj) {
      toast.error('Preencha o campo CNPJ', {});
      return;
    }
    if (!validarCNPJ(EmpresaStore.obs.cnpj)) {
      toast.error('CNPJ inválido', {});
      return;
    }
    if (!EmpresaStore.obs.razao_social) {
      toast.error('Preencha o campo Razão social', {});
      return;
    }

    if (!EmpresaStore.obs.nome_fantasia) {
      toast.error('Preencha o campo Nome Fantasia', {});
      return;
    }

    if (EmpresaStore.obs.inscricao_estadual != "") {

      let inscricaoEstadual = (EmpresaStore.obs.inscricao_estadual?.replace(/[^0-9]/g, '')).toString()

      EmpresaStore.obs.inscricao_estadual = inscricaoEstadual;

    }

    if (!EmpresaStore.obs.regime_importacao) {
      toast.error('Selecione o regime da Empresa', {});
      return;
    }

    if (
      EmpresaStore.obs.simples_nacional == "Selecione" ||
      EmpresaStore.obs.simples_nacional_excesso == "Selecione" ||
      EmpresaStore.obs.regime_especial_icms_pa == "Selecione" ||
      EmpresaStore.obs.convenio_icms_100_97 == "Selecione" ||
      EmpresaStore.obs.porta_a_porta == "Selecione"
    ) {
      toast.error('Selecione as tributações da Empresa', {});
      return;
    }

    this.props.doSave();

  };

  dadosEmpresa() {
    return (
      <MDBCol>
        {/* <h3 className="titleProccess">Dados da Empresa</h3> */}
        <p><b>CNPJ:</b> {EmpresaStore.obs.cnpj}</p>
        <p><b>Razão Social:</b> {EmpresaStore.obs.razao_social}</p>
        <p><b>Nome Fantasia:</b> {EmpresaStore.obs.nome_fantasia}</p>
        <p><b>Inscrição Estadual:</b> {EmpresaStore.obs.inscricao_estadual}</p>
        <p><b>Tipo de Cadastro:</b>{" "}{EmpresaStore.obs.filial ? "FILIAL" : "MATRIZ"}</p>
        <p><b>Regime da Empresa:</b> {EmpresaStore.obs.regime_importacao}</p>
        <p><b>Municipio:</b> {EmpresaStore.obs.empresa.municipio}</p>
        <p><b>Estado:</b> {EmpresaStore.obs.empresa.uf}</p>
      </MDBCol>
    )
  }

  tributacaoEmpresa() {
    return (
      <MDBCol >
        {/* <h3 className="titleProccess">Tributações</h3> */}
        <p><b>Regime Simples Nacional:</b>{" "}{EmpresaStore.obs.simples_nacional == "1" ? "Sim" : "Não"}</p>
        <p><b>Excesso de Sublimite de Receita Bruta:</b>{" "}{EmpresaStore.obs.simples_nacional_excesso == "1" ? "Sim" : "Não"}</p>
        <p><b>Regime Especial:</b>{" "}{EmpresaStore.obs.regime_especial_icms_pa == "1" ? "Sim" : "Não"}</p>
        <p><b>Convênio ICMS 100/97:</b>{" "}{EmpresaStore.obs.convenio_icms_100_97 == "1" ? "Sim" : "Não"}</p>
        <p><b>Operação de Venda na Modalidade Porta a Porta:</b> {EmpresaStore.obs.porta_a_porta == "1" ? "Sim" : "Não"}</p>
      </MDBCol>
    )
  }

  segmentosEmpresa() {
    return (
      <div style={{ overflow: "auto", height: 480 }}>
        <MDBCol>

          <p><b>Comercializa tintas e vernizes:</b>{" "}{EmpresaStore.obs.seg_tintas == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos veterinário/pet:</b>{" "}{EmpresaStore.obs.seg_vet_pet == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos de autopeças:</b>{" "}{EmpresaStore.obs.seg_auto_pecas == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa refrigerantes:</b>{" "}{EmpresaStore.obs.seg_refrigerantes == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa águas e outras bebidas:</b>{" "}{EmpresaStore.obs.seg_agua_out == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa lâmpadas, reatores e starter:</b>{" "}{EmpresaStore.obs.seg_lamp_reatores == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa materiais de limpeza:</b>{" "}{EmpresaStore.obs.seg_mat_limpeza == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos alimentícios:</b>{" "}{EmpresaStore.obs.seg_alimenticios == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa veículos automotores novos:</b>{" "}{EmpresaStore.obs.seg_veiculos_automotores == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa rações para animais domésticos:</b>{" "}{EmpresaStore.obs.seg_racoes == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa veículos novos de duas e três rodas motorizados:</b>{" "}{EmpresaStore.obs.seg_veiculos_novos == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos de material de construção:</b>{" "}{EmpresaStore.obs.seg_mat_construcao == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa medicamentos de uso humano e outros produtos farmacêuticos:</b>{" "}{EmpresaStore.obs.seg_medicamentos_humano == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos pneumáticos, câmaras de ar e protetores de borracha:</b>{" "}{EmpresaStore.obs.seg_pneumaticos_prot == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos de perfumaria e de higiene pessoal e cosméticos:</b>{" "}{EmpresaStore.obs.seg_perf_cosm == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa produtos eletrônicos, eletroeletrônicos e eletrodomésticos:</b>{" "}{EmpresaStore.obs.seg_eletro == "1" ? "Sim" : "Não"}</p>
          <p><b>Comercializa sorvetes e preparados para fabricação de sorvetes em máquinas:</b>{" "}{EmpresaStore.obs.seg_sorvetes_fab == "1" ? "Sim" : "Não"}</p>
        </MDBCol>

      </div>)
  }

  render() {

    const HorizontalLinearStepper = () => {

      const isStepOptional = (step: number) => {
        return step === 3;
      };

      const handleNext = () => {
        this.obs.activeStep = this.obs.activeStep + 1
      };

      const handleBack = () => {
        this.obs.activeStep = this.obs.activeStep - 1
      };

      return (
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={this.obs.activeStep}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (isStepOptional(index)) {
                labelProps.optional = (
                  <Typography variant="caption">Opcional</Typography>
                );
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <React.Fragment>
            <br />
            {this.obs.activeStep == 0 && this.dadosEmpresa()}
            {this.obs.activeStep == 1 && this.tributacaoEmpresa()}
            {this.obs.activeStep == 2 && this.segmentosEmpresa()}
            <MDBCol>
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                {this.obs.activeStep > 0 ?
                  <ButtonJS
                    color="inherit"
                    onClick={handleBack}
                  >
                    Voltar
                  </ButtonJS>
                  :
                  <ButtonJS
                    text="Cancelar"
                    onClick={() => this.props.onClose()}
                    className="btnCancelEmp"
                    disabled={EmpresaStore.obs.working}
                  />
                }

                <Box sx={{ flex: '1 1 auto' }} />
                {this.obs.activeStep === steps.length - 1
                  ? <ButtonJS className="btnCadastraEmp"
                    onClick={this.handleSave}
                    loading={EmpresaStore.obs.working}>
                    {'Finalizar'}
                  </ButtonJS>
                  :
                  <ButtonJS onClick={handleNext} className="btnCadastraEmp">
                    {'Próximo'}
                  </ButtonJS>
                }
              </Box>
            </MDBCol>
          </React.Fragment>
        </Box>
      );
    }

    return (
      <>

        {HorizontalLinearStepper()}

      </>
    );
  }
}
